import { FormsPortalWorkspace } from '@/features/forms-portal/components/FormsPortalWorkspace';

export function FormsPortalPage() {
  return (
    <section className="page-card">
      <FormsPortalWorkspace headerEyebrow="Assigned Forms" headerTitle="Forms Portal" />
    </section>
  );
}
